import Thumb from './thumb';

export default class ThumbShape extends Thumb {
  constructor (parameters) {
    super();

    this.height = 122.5;

    this.path = null;
    this.size = 300;

    this.type = 'Shape';

    this.setValues(parameters);
  }

  getVB () {
    const off = this.size * 0.05;
    const x = 0;
    const y = 0;
    const width = this.size;
    const height = this.size;

    return [x - off, y - off, width + off * 2, height + off * 2];
  }

  getItem () {
    const $container = this.getItemContainer();

    const stroke = this.size / 300;

    const shapeIcon = new DOMParser().parseFromString(
      '<svg xmlns="http://www.w3.org/2000/svg"><path fill="#fff" stroke="#000" stroke-width="' + stroke + '" /></svg>',
      'text/xml');

    const $svgElem = $(document.importNode(shapeIcon.documentElement, true));
    const $path = $svgElem.find('path');
    $path.attr('d', this.path);

    $container.find('a').append($svgElem);

    $svgElem.attr('width', this.width);
    $svgElem.attr('height', this.height);

    $svgElem.attr('viewBox', this.getVB().join(' '));

    $container.css('height', this.height);

    return $container;
  }

  _addElement (bb, x, y) {
    /*
      var canvas = INKIVE.Tool.getInstance().editor.canvas;
      var scale = Math.min(canvas.contentW, canvas.contentH);
      scale /= Math.max(bb.width, bb.height);

      INKIVE.DesignFacade.create('shape', {
          content  : this.path,
          position : { x: x, y: y },
          size     : {
              width  : bb.width * (scale / 2),
              height : bb.height * (scale / 2)
          }
      });
      */
    let path = this.path;

    const editor = INKIVE.Tool.getInstance().editor;
    const canvas = editor.canvas;

    const g = canvas.addSvgElementFromJson({
      element: 'g',
      attr: {
        id: editor.canvas.getNextId()
      }
    });

    const curShape = editor.canvas.addSvgElementFromJson({
      element: 'path',
      curStyles: true,
      attr: {
        d: path,
        id: editor.canvas.getNextId(),
        opacity: 1.0
      }
    }, g);

    curShape.setAttribute('class', 'element');

    // Make sure shape uses absolute values
    if (/[a-z]/.test(path)) {
      path = editor.canvas.pathActions.convertPath(curShape);
      curShape.setAttribute('d', path);
      editor.canvas.pathActions.fixEnd(curShape);
    }

    INKIVE.Helpers.resize(g, canvas.contentW, canvas.contentH, x, y);

    g.parentElement.insertBefore(g.firstChild, g);
    g.parentElement.removeChild(g);

    canvas.selectOnly([curShape]);

    const batchCmd = new svgedit.history.BatchCommand('Paste elements');
    batchCmd.addSubCommand(new svgedit.history.InsertElementCommand(curShape));
    editor.canvas.undoMgr.addCommandToHistory(batchCmd);

    INKIVE.Tool.blinkScreen(curShape);

    return curShape;
  }

  onItemClick (item) {
    const editor = INKIVE.Tool.getInstance().editor;
    const canvas = editor.canvas;

    const bb = item.getBoundingClientRect();
    const x = (canvas.contentW - bb.width) / 2;
    const y = (canvas.contentH - bb.height) / 2;

    return this._addElement(bb, x, y);
  }

  onItemRelease (item) {
    const editor = INKIVE.Tool.getInstance().editor;

    const bb = this.getItemContainer().get(0).getBoundingClientRect();
    const zoom = INKIVE.EditorFacade.handle('zoom', 'get');
    const offset = editor.getOffset();

    const x = Math.floor4((bb.left - offset.x) / zoom);
    const y = Math.floor4((bb.top - offset.y) / zoom);

    return this._addElement(bb, x, y);
  }
}
